import { render, staticRenderFns } from "./NewsDetailsTwo.vue?vue&type=template&id=dd1f31e0"
import script from "./NewsDetailsTwo.vue?vue&type=script&lang=js"
export * from "./NewsDetailsTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsTwo.vue?vue&type=style&index=0&id=dd1f31e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports